export default __webpack_public_path__ + "static/media/fun.89421a4e.png";